export default __webpack_public_path__ + "static/media/Hiw2.ffde910c.jpg";